import style from './App.css'

const rootClassName = style.polopoly_widget

const storyConfig = {
  rootClassName,
  docId: '1YGAuO-By2ObYe92QYcAZApqc16k2AUQAvHhh7JDKlQw'
}

export { rootClassName }

export default storyConfig
